import type { FC, ReactNode } from 'react';
import { useCallback } from 'react';
import type { GestureResponderEvent } from 'react-native';

import { FavoriteFilledIcon, FavoriteIcon } from '@/assets';
import { LabelButton } from '@/features/posts/components/LabelButton';
import { useAppTheme } from '@/styles/hooks/useAppTheme';

type LikeButtonProps = {
  handleLikeToggle: (e: GestureResponderEvent) => void;
  liked: boolean | null;
  disabled: boolean;
  likeCount: number;
  testID?: string;
};

export const LikeButton: FC<LikeButtonProps> = ({
  handleLikeToggle,
  liked,
  disabled,
  likeCount,
  testID
}) => {
  const theme = useAppTheme();

  const onPress = useCallback(
    (event: GestureResponderEvent) => {
      if (disabled) {
        return;
      }
      handleLikeToggle(event);
    },
    [disabled, handleLikeToggle]
  );

  const icon = useCallback(
    (props: { color: string; size: number }): ReactNode =>
      liked ? (
        <FavoriteFilledIcon
          fill={props.color}
          width={props.size}
          height={props.size}
        />
      ) : (
        <FavoriteIcon
          fill={props.color}
          width={props.size}
          height={props.size}
        />
      ),
    [liked]
  );

  return (
    <LabelButton
      testID={testID}
      onPress={onPress}
      icon={icon}
      textColor={liked ? theme.colors.error : theme.colors.primary}
    >
      {likeCount}
    </LabelButton>
  );
};
